import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import MdmLink from '~/components/atoms/MdmLink.vue';
export default {
  name: 'SitemapList',
  components: {
    MdmLink: MdmLink
  },
  props: {
    items: {
      type: Array,
      required: true
    }
  }
};